// Onboarding TOUR guiado (LandHo!) — spotlight + tooltip sobre RadarTierra.
// - Se dispara solo la PRIMERA vez (flag localStorage `landho-tour-visto`).
// - Re-lanzable desde el sidebar ("Hacé el tour").
// - Regla de robustez: si un elemento no está en el DOM, el paso se saltea
//   silenciosamente (no romper el tour para cuentas vacías).
// - Regla de honestidad: textos factuales (catastro oficial, sin costo).
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./tour.css";

export const TOUR_STORAGE_KEY = "landho-tour-visto";
export const TOUR_START_EVENT = "landho:start-tour";

// Todos los pasos del tour. `element: null` → popover centrado (sin spotlight).
const ALL_STEPS = [
  {
    element: null,
    popover: {
      title: "¡Bienvenido a LandHo! 👋",
      description:
        "El radar que encuentra oportunidades de tierra antes que la competencia. Te muestro lo básico en 1 minuto — podés saltarlo cuando quieras.",
    },
  },
  {
    element: '[data-testid="sidebar"]',
    popover: {
      title: "Tus secciones",
      description:
        "<strong>Tierra</strong> es el corazón: el catastro oficial + las oportunidades de suelo. <strong>Inmuebles</strong> son los avisos publicados. Después: Listados y Ajustes.",
      side: "right",
      align: "start",
    },
  },
  {
    element: '[data-tour="zona-controls"]',
    popover: {
      title: "Elegí o creá una zona",
      description:
        "Todo arranca por una zona. Elegí una zona o creá la tuya: un barrio, un cuadrante de 4 calles, o un punto + radio. El sistema trae todo lo de esa zona.",
      side: "right",
      align: "start",
    },
  },
  {
    element: '[data-testid="btn-buscar-idecor"]',
    popover: {
      title: "Traé el catastro",
      description:
        "Con la zona elegida, este botón trae los lotes oficiales de la Provincia — <strong>sin costo</strong>.",
      side: "right",
      align: "start",
    },
  },
  {
    element: ".leaflet-container",
    popover: {
      title: "La ficha del lote",
      description:
        "Clickeá un lote y vas a ver su valuación oficial, los m² construibles (con el FOT) y links a Catastro y Rentas. Cada dato tiene un <strong>?</strong> que lo explica. Lo que un tasador calcula a mano, acá en un clic.",
      side: "left",
      align: "center",
    },
  },
  {
    element: '[data-testid="tierra-controles-capas"]',
    popover: {
      title: "Panel de capas",
      description:
        "Prendé las capas según lo que busques: Rural (campos), Publicado (terrenos en venta), Loteos aprobados, Riesgo hídrico.",
      side: "left",
      align: "start",
    },
  },
  {
    element: '[data-tour="filtros"]',
    popover: {
      title: "Filtrá y encontrá",
      description:
        "Superficie, valor por m², pisos permitidos… El sistema hace el reconocimiento; vos entrás solo donde hay que decidir.",
      side: "right",
      align: "start",
    },
  },
  {
    element: null,
    popover: {
      title: "¡Listo!",
      description:
        "Explorá tranquilo. Cuando quieras repetir este tour, lo tenés siempre en el menú: <strong>“Hacé el tour”</strong>.",
    },
  },
];

// Filtra los pasos cuyos elementos no existen en el DOM. Deja pasar los pasos
// centrados (element === null). Esto garantiza que una cuenta vacía (sin zona
// activa, sin lote clickeado, etc.) no rompa el tour.
function getVisibleSteps() {
  return ALL_STEPS.filter((step) => {
    if (!step.element) return true;
    return !!document.querySelector(step.element);
  });
}

// Marca el tour como visto (bloquea el auto-arranque futuro).
function markTourAsSeen() {
  try {
    localStorage.setItem(TOUR_STORAGE_KEY, "1");
  } catch (e) {
    console.error("No se pudo guardar el flag del tour", e);
  }
}

export function hasSeenTour() {
  try {
    return localStorage.getItem(TOUR_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

// Arranca el tour. Guarda el flag al terminar/cerrar (nunca vuelve a auto-arrancar).
export function startLandHoTour() {
  const steps = getVisibleSteps();
  if (steps.length === 0) return;

  const driverObj = driver({
    showProgress: true,
    allowClose: true,
    overlayOpacity: 0.6,
    stagePadding: 6,
    stageRadius: 0,
    nextBtnText: "Siguiente →",
    prevBtnText: "← Anterior",
    doneBtnText: "Terminar tour",
    progressText: "{{current}} de {{total}}",
    steps,
    onDestroyed: () => markTourAsSeen(),
  });

  driverObj.drive();
}
